import Alpine from "alpinejs";

// Auto-registers all Alpine components from this directory.
// File name determines the component name (kebab-case → camelCase):
//   order-part-form.js → x-data="orderPartForm()"
//   trip-edit.js       → x-data="tripEdit()"
// Each file must export a default function.
const modules = require.context(".", false, /^\.\/(?!index).*\.js$/);

modules.keys().forEach((fileName) => {
  const module = modules(fileName);
  const componentName = fileName
    .replace("./", "")
    .replace(".js", "")
    .replace(/-([a-z])/g, (_, c) => c.toUpperCase());

  Alpine.data(componentName, module.default);
});
